'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var DEFAULT_URL = "https://fulfillmentlocation.trdlnk.cimpress.io";
var nodeCache = require('node-cache');
var flCache = void 0;
var axios = require('axios');

// --- Predefined errors ---

function UnauthorizedError(message, extra) {
  Error.captureStackTrace(this, this.constructor);
  this.name = this.constructor.name;
  this.message = message || 'Unauthorized';
  this.status = 401;
  this.additionalData = extra;
}
function ForbiddenError(message, extra) {
  Error.captureStackTrace(this, this.constructor);
  this.name = this.constructor.name;
  this.message = message || 'Forbidden';
  this.status = 403;
  this.additionalData = extra;
}
function NotFoundError(message, extra) {
  Error.captureStackTrace(this, this.constructor);
  this.name = this.constructor.name;
  this.message = message || 'Not found';
  this.status = 404;
  this.additionalData = extra;
}

// --- END ---

var handleAuthorization = function handleAuthorization(authorization, reject) {
  if (!authorization) {
    return reject(new Error('Missing Authorization parameter'));
  }
  if (authorization.indexOf('Bearer ') !== 0) {
    return reject(new Error('Invalid format for Authorization parameter: "' + authorization + '". Authorization parameter should be in the following' + ' format: "Bearer [token]"'));
  }
};
var handleError = function handleError(err, reject) {
  if (err.status === 401 || err.response && err.response.status === 401) {
    return reject(new UnauthorizedError(err.statusText || err.message, err.data || err.response.data));
  }
  if (err.status === 403 || err.response && err.response.status === 403) {
    return reject(new ForbiddenError(err.statusText || err.message, err.data || err.response.data));
  }
  if (err.status === 404 || err.response && err.response.status === 404) {
    return reject(new NotFoundError(err.statusText || err.message, err.data || err.response.data));
  }
  return reject(err);
};
var FulfillmentLocationClient = function () {
  function FulfillmentLocationClient(c) {
    _classCallCheck(this, FulfillmentLocationClient);
    var config = c || {};
    this.url = config.url || DEFAULT_URL;
    this.log = config.log;
    this.useCaching = !!config.cacheConfig;
    if (config.cacheConfig) {
      flCache = new nodeCache(config.cacheConfig);
    }
    this.timeout = config.timeout || 2000;
  }
  _createClass(FulfillmentLocationClient, [{
    key: 'getLocation',
    value: function getLocation(locationId, authorization) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        handleAuthorization(authorization, reject);
        var instance = axios.create({
          baseURL: _this.url,
          timeout: _this.timeout
        });
        instance.defaults.headers.common['Authorization'] = authorization;
        if (!_this.useCaching) {
          return _this._getFulfillmentLocationFromService(instance, locationId).then(function (location) {
            return resolve(location);
          }).catch(function (err) {
            return reject(err);
          });
        }
        var cacheKey = 'fulfillmentLocation_' + locationId + '_' + authorization;
        flCache.get(cacheKey, function (err, fulfillmentLocation) {
          if (err) {
            _this.log.error('Failed to read from node-cache (key=' + cacheKey + ')', err);
          }
          if (err || fulfillmentLocation == undefined) {
            return _this._getFulfillmentLocationFromService(instance, locationId).then(function (location) {
              flCache.set(cacheKey, location);
              return resolve(location);
            }).catch(function (err) {
              return reject(err);
            });
          } else {
            return resolve(fulfillmentLocation);
          }
        });
      });
    }
  }, {
    key: 'getLocations',
    value: function getLocations(authorization) {
      var _this2 = this;
      var showArchived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        handleAuthorization(authorization, reject);
        var instance = axios.create({
          baseURL: _this2.url,
          timeout: _this2.timeout
        });
        instance.defaults.headers.common['Authorization'] = authorization;
        if (!_this2.useCaching) {
          return _this2._getFulfillmentLocationsFromService(instance, showArchived).then(function (locations) {
            return resolve(locations);
          }).catch(function (err) {
            return reject(err);
          });
        }
        var cacheKey = 'fulfillmentLocations_' + authorization;
        flCache.get(cacheKey, function (err, fulfillmentLocations) {
          if (err) {
            _this2.log.error('Failed to read from node-cache (key=' + cacheKey + ')!?', err);
          }
          if (err || fulfillmentLocations == undefined) {
            return _this2._getFulfillmentLocationsFromService(instance, showArchived).then(function (locations) {
              flCache.set(cacheKey, locations);
              return resolve(locations);
            }).catch(function (err) {
              return reject(err);
            });
          } else {
            return resolve(fulfillmentLocations);
          }
        });
      });
    }
  }, {
    key: '_getFulfillmentLocationFromService',
    value: function _getFulfillmentLocationFromService(instance, fulfillmentLocationId) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var endpoint = _this3.url + "/v1/fulfillmentlocations/" + fulfillmentLocationId;
        var requestConfig = {
          method: 'GET',
          url: endpoint,
          timeout: _this3.timeout
        };
        if (_this3.log && _this3.log.info) {
          _this3.log.info("->" + endpoint, requestConfig);
        }
        instance.request(requestConfig).then(function (res) {
          if (_this3.log && _this3.log.info) {
            _this3.log.info("<-" + endpoint, res.data);
          }
          return resolve(res.data || []);
        }).catch(function (err) {
          if (_this3.log && _this3.log.error) {
            _this3.log.error("<-" + endpoint, err);
          }
          return handleError(err, reject);
        });
      });
    }
  }, {
    key: '_getFulfillmentLocationsFromService',
    value: function _getFulfillmentLocationsFromService(instance, showArchived) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var endpoint = _this4.url + "/v1/fulfillmentlocations";
        var requestConfig = {
          method: 'GET',
          url: endpoint,
          params: {
            showArchived: showArchived
          },
          timeout: _this4.timeout
        };
        if (_this4.log && _this4.log.info) {
          _this4.log.info("->" + endpoint, requestConfig);
        }
        instance.request(requestConfig).then(function (res) {
          if (_this4.log && _this4.log.info) {
            _this4.log.info("<-" + endpoint, res.data);
          }
          return resolve(res.data || []);
        }).catch(function (err) {
          if (_this4.log && _this4.log.error) {
            _this4.log.error("<-" + endpoint, err);
          }
          return handleError(err, reject);
        });
      });
    }
  }]);
  return FulfillmentLocationClient;
}();
module.exports = FulfillmentLocationClient;